<template>
    <div data-testid="cambio-datos-paso-seleccion">
        <CardFront>
            <div class="tw:flex tw:justify-between tw:gap-3 tw:pb-3 tw:border-b tw:border-slate-100 tw:mb-3">
                <div class="tw:flex tw:gap-3 tw:items-center">
                    <ToggleSwitch
                        data-testid="cambio-datos-select-all"
                        :value="isAllSelected"
                        variant="alt"
                        size="md"
                        @input="toggleAll"
                    />
                    <label class="tw:text-sm tw:text-slate-500 tw:m-0">
                        {{ $t('perfil.cambio_datos.seleccionar_todas') }}
                    </label>
                </div>
                <span class="tw:text-slate-500">{{ entradas.length }} {{ entradas.length === 1 ? $t('perfil.cambio_datos.entrada_disponible') : $t('perfil.cambio_datos.entradas_disponibles') }}</span>
            </div>

            <div class="tw:space-y-2">
                <label
                    v-for="entrada in entradas"
                    :key="entrada.id"
                    class="tw:flex tw:items-center tw:gap-3 tw:p-3 tw:rounded-xl tw:border tw:border-slate-100 tw:cursor-pointer tw:hover:bg-slate-50 tw:transition-colors"
                    :class="{ 'tw:bg-red-50 tw:border-red-200': isSelected(entrada) }"
                >
                    <ToggleSwitch
                        :value="isSelected(entrada)"
                        variant="alt"
                        size="md"
                        @input="value => toggleEntrada(entrada, value)"
                    />
                    <div class="tw:grid tw:grid-cols-1 tw:sm:grid-cols-3 tw:gap-2 tw:flex-1 tw:min-w-0">

                        <div>
                            <p class="tw:text-[10px] tw:font-bold tw:text-slate-400 tw:uppercase tw:m-0">{{ $t('perfil.entrada_detalle.titular') }}</p>
                            <p class="tw:text-sm tw:text-slate-900 tw:m-0 tw:leading-tight">
                                {{ entrada.user_nombre  }}  <span>{{ entrada.user_apellidos }}</span>
                            </p>
                            <p class="tw:text-xs tw:text-slate-500 tw:font-mono tw:m-0">{{ entrada.user_dni }}</p>
                        </div>

                        <div>
                            <p class="tw:text-[10px] tw:font-bold tw:text-slate-400 tw:uppercase tw:m-0">{{ $t('perfil.entrada_detalle.ubicacion') }}</p>
                            <p class="tw:text-sm tw:text-slate-900 tw:m-0">{{ getUbicacion(entrada).zona }}</p>
                            <p class="tw:text-[10px] tw:text-slate-500 tw:font-bold tw:uppercase tw:m-0">
                                {{ $t('perfil.entrada_detalle.fila_asiento', { fila: getUbicacion(entrada).fila, asiento: getUbicacion(entrada).asiento }) }}
                            </p>
                        </div>

                        <div>
                            <p class="tw:text-[10px] tw:font-bold tw:text-slate-400 tw:uppercase tw:m-0">{{ $t('perfil.entrada_detalle.qr_code') }}</p>
                            <p class="tw:text-sm tw:text-slate-900 tw:m-0 tw:leading-tight">
                                {{ entrada.qr_code || '-' }} 
                            </p>
                        </div>
                    </div>
                </label>
            </div>

        </CardFront>

        <!-- Footer actions -->
        <div class="tw:flex tw:justify-between tw:items-center tw:gap-3 tw:mt-4">
            <Button data-testid="cambio-datos-btn-volver" variant="default" @click="emit('volver')">
                <i class="material-icons tw:text-sm">arrow_back</i>
                {{ $t('perfil.cambio_datos.volver_pedido') }}
            </Button>
            <Button
                data-testid="cambio-datos-btn-continuar"
                variant="alt"
                :disabled="localSeleccionadas.length === 0"
                @click="handleContinuar"
            >
                {{ $t('perfil.cambio_datos.continuar') }}
                <i class="material-icons tw:text-sm">arrow_forward</i>
            </Button>
        </div>
    </div>
</template>

<script setup>
    import { ref, computed } from 'vue';
    import CardFront from '@/modules/front/ui/CardFront.vue';
    import Button from '@/modules/front/ui/Button.vue';
    import ToggleSwitch from '@/modules/front/ui/ToggleSwitch.vue';
    import { getUbicacion } from '@/composables/front/perfil/useUbicacionEntrada';

    const props = defineProps({
        pedido: { type: Object, required: true },
    });

    const emit = defineEmits(['volver', 'continuar']);

    const entradas = computed(() => props.pedido?.entradas || []);
    const localSeleccionadas = ref([]);

    const isSelected = entrada =>
        localSeleccionadas.value.some(e => e.id === entrada.id);

    const isAllSelected = computed(() =>
        entradas.value.length > 0 && localSeleccionadas.value.length === entradas.value.length
    );

    const toggleEntrada = (entrada, shouldSelect) => {
        if (shouldSelect) {
            if (!isSelected(entrada)) {
                localSeleccionadas.value = [...localSeleccionadas.value, entrada];
            }
        } else {
            localSeleccionadas.value = localSeleccionadas.value.filter(e => e.id !== entrada.id);
        }
    };

    const toggleAll = shouldSelectAll => {
        if (shouldSelectAll) {
            localSeleccionadas.value = [...entradas.value];
        } else {
            localSeleccionadas.value = [];
        }
    };

    const handleContinuar = () => {
        emit('continuar', localSeleccionadas.value);
    };
</script>
